import { ATTORNEY_INFO_CONFIG, getAttorneySurfaceConfig } from "../../../features/bonds/shared/attorneyInformationConfig";

const historicSurface = getAttorneySurfaceConfig("historic");

/** Historic bond creation attorney step — extends bond wizard config (Phase 14). */
export const HISTORIC_ATTORNEY_INFO_CONFIG = {
  probate: {
    ...ATTORNEY_INFO_CONFIG.probate,
    ...historicSurface,
    isHistoric: true,
    useDebouncedAttorneySearch: false,
  },
  va: {
    ...ATTORNEY_INFO_CONFIG.va,
    ...historicSurface,
    isHistoric: true,
    useDebouncedAttorneySearch: false,
    pgAutoSetToNo: false,
    pgAutoSetToNoHistoric: true,
    refetchLawFirmsOnAttorneyInvolvedChange: true,
    showToggleOnlyWhenNotGuest: false,
  },
  trustee: {
    ...ATTORNEY_INFO_CONFIG.trustee,
    ...historicSurface,
    isHistoric: true,
    useDebouncedAttorneySearch: false,
    pgAutoSetToNo: false,
    pgAutoSetToNoHistoric: true,
    showToggleOnlyWhenNotGuest: false,
  },
  guardianship: {
    ...ATTORNEY_INFO_CONFIG.guardianship,
    ...historicSurface,
    isHistoric: true,
    useDebouncedAttorneySearch: false,
    pgAutoSetToNo: false,
    pgAutoSetToNoHistoric: true,
    showToggleOnlyWhenNotGuest: false,
  },
};
